var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-header"},[_c('div',{staticClass:"toolbar",class:{'smaller-toolbar': _vm.small}},[_c('navigation-menu',{staticClass:"menu",attrs:{"user":_vm.user,"isUserSet":_vm.isUserSet,"isAdmin":_vm.isAdmin}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }